import PropTypes from 'prop-types';
import pick from 'lodash/pick';
var propTypes = {
  readOnly: PropTypes.bool,
  coordinates: PropTypes.array.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  handleSetCoordinates: PropTypes.func
};
export default propTypes;
export var defaultProps = {
  readOnly: false
};
export var pickProps = function pickProps(props) {
  return pick(props, Object.keys(propTypes));
};